/** Build a 6-week month grid (Mon-first) covering the given month. */
export interface MonthGrid {
  /** YYYY-MM-DD for the first and last visible cell (for the API from/to). */
  from: string;
  to: string;
  /** 42 cells (6 weeks × 7 days). */
  days: Array<{ date: Date; iso: string; inMonth: boolean; isToday: boolean }>;
}

const toIso = (d: Date): string =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

/** Local YYYY-MM-DD for an ISO instant — matches this grid's local `iso` so day-grouping lines up. */
export const localDayKey = (iso: string): string => toIso(new Date(iso));

export function buildMonthGrid(year: number, month: number): MonthGrid {
  const first = new Date(year, month, 1);
  // Monday-first offset (JS getDay: 0=Sun).
  const offset = (first.getDay() + 6) % 7;
  const start = new Date(year, month, 1 - offset);
  const todayIso = toIso(new Date());

  const days = Array.from({ length: 42 }, (_, i) => {
    const date = new Date(start.getFullYear(), start.getMonth(), start.getDate() + i);
    const iso = toIso(date);
    return {
      date,
      iso,
      inMonth: date.getMonth() === month,
      isToday: iso === todayIso,
    };
  });

  return { from: days[0].iso, to: days[days.length - 1].iso, days };
}

export const WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
